module.exports = "<wow-card-list>\r\n    <h2 class=\"cardList-header hidden-xs\" ng-if=\"richRelevanceProductsCtrl.showTitle\">{{richRelevanceProductsCtrl.title}}</h2>\r\n    <wow-shelf-product-tile ng-repeat=\"product in richRelevanceProductsCtrl.products\" product=\"product\"></wow-shelf-product-tile>\r\n</wow-card-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/richrelevance/rr-products.component.html
// module id = 313
// module chunks = 0 2